<template>
    <wrapper
        project="games"
        headerHeight="40px"
        :request="searchData"
        :params="params"
    >
        <template slot="toolbar" slot-scope="scope">
            <tg-search-tool
                :data="searchData"
                @on-submit="handleSearch(scope.onSearch)"
            >
                <el-input
                    :placeholder="$t('component.form.input.placeholder.game')"
                    v-model="searchData.targetName"
                    class="tg-input"
                    size="small"
                    style="width: 240px"
                    clearable
                ></el-input>
            </tg-search-tool>
        </template>

        <!-- 平台 -->
        <template slot="source_type" slot-scope="scope">
            <span :class="['text-' +  scope.row.source_type]">
                {{ $t("component.label.source_type." + scope.row.source_type) }}
            </span>
        </template>

        <!-- 單號 -->
        <template slot="betId" slot-scope="scope">
            <tg-bet-id :row="scope.row"></tg-bet-id>
        </template>

        <!-- 賽事內容 -->
        <template slot="game_name" slot-scope="scope">
            <tg-bet-content :row="scope.row" closeOdd></tg-bet-content>
        </template>

        <template slot="link" slot-scope="scope">
            <a
                v-if="scope.value > 0"
                @click.prevent="handleGoToDetail(scope)"
                href
            >
                {{ scope.formated }}
            </a>
            <span v-else>{{ scope.formated }}</span>
        </template>
    </wrapper>
</template>

<script>
import wrapper from "./wrapper";
import TgSearchTool from "@/components/tool/TgSearchTool";
import minins from "./mixins";

import TgBetId from "@/components/slot/TgBetId";
import TgBetContent from "@/components/slot/TgBetContent";

export default {
    components: {
        wrapper,
        TgSearchTool,
        TgBetId,
        TgBetContent
    },
    mixins: [minins],
    methods: {
        handleGoToDetail(scope) {
            let username = this.params.username;

            let keyData = {
                event: scope.row["event"],
                game_name: scope.row["game_name"],
                game_time: scope.row["game_time"],
                game_key: scope.row["game_key"],
                username,
                source_type: scope.row["source_type"],
            };

            let params = {
                ...this.params,
                ...keyData,
                reward: scope.column.reward,
                title: scope.column.title,
            };

            let historyKey = this.$history.add(params, keyData);

            this.$router.push({
                name: "tg_business.member.reward.detail",
                params: { username },
                query: { h: historyKey },
            });
        },
        handleSearchThirdParty(value) {
            this.third_party = value;
            this.$nextTick(() => {
                this.handleSearch();
            });
        },
    },
};
</script>
